export default __webpack_public_path__ + "static/media/shortLogoLeadsRubix1.c810435e.png";